import { render, staticRenderFns } from "./TaskLinks.vue?vue&type=template&id=d186b07e&lang=pug"
import script from "./TaskLinks.vue?vue&type=script&lang=js"
export * from "./TaskLinks.vue?vue&type=script&lang=js"
import style0 from "./TaskLinks.vue?vue&type=style&index=0&id=d186b07e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports